import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Cover, Cursor, StarsCanvas } from './components';
import { About, Home, Project, Projects } from './pages';
import { GlobalStyles } from './styles/globalStyles';
import './App.scss';

const App = () => {
  const location = useLocation();
  const root = document.documentElement;
  const width = window.innerWidth;

  window.addEventListener('resize', () => {
    const newWidth = window.innerWidth;
    if (newWidth < 500) {
      if (newWidth !== width) {
        window.location.reload();
      }
    } else {
      window.location.reload();
    }
  });

  useEffect(() => {
    root.style.setProperty('--VW', `${window.innerWidth * 0.01}px`);
    root.style.setProperty('--VH', `${window.innerHeight * 0.01}px`);
  }, [root.style]);

  return (
    <div className="App">
      <GlobalStyles />
      <Cover />
      <Cursor />

      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectID" element={<Project />} />
        <Route path="/about" element={<About />} />
      </Routes>

      <StarsCanvas />
    </div>
  );
};

export default App;
